/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiAuthBarberLogoutMutationResponse, PostApiAuthBarberLogout401 } from "../entities/PostApiAuthBarberLogout";

function getPostApiAuthBarberLogoutUrl() {
  const res = { method: 'POST', url: `/api/auth/barber/logout` as const }
  return res
}

/**
 * @description Очистить файлы cookie для авторизации мастера
 * @summary Выход из системы мастера
 * {@link /api/auth/barber/logout}
 */
export async function postApiAuthBarberLogout(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PostApiAuthBarberLogoutMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogout401>, unknown>({ method : "POST", url : getPostApiAuthBarberLogoutUrl().url.toString(), ... requestConfig })
  return res.data
}